import StampHistoryPage from './StampHistoryPage';

export default StampHistoryPage;
